<template>
  <div class="well" style="padding: 0 1em;">
    <table cellpadding="0" cellspacing="0" class="ncut-table-search">
      <tbody>
        <tr>
          <td class="ncut-base-form-text" style="width:7rem;">統計年度：</td>
          <td class="ncut-base-form-ipt" style="width:7rem;" colspan="2">
            <b-form-select label-for="input-2" tabindex="2" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem;"
              v-model="queryInfo.id"
              placeholder="請輸入統計年度...">
              <b-form-select-option
                v-for="i in (nYear[1] - nYear[0] + 1)"
                :key="'Y'+i"
                :value="(i + nYear[0])+''">{{i + nYear[0]}}年</b-form-select-option>
            </b-form-select>
          </td>
          <td class="ncut-base-form-text" style="width:6em;">報表類型：</td>
          <td class="ncut-base-form-ipt" style="width:7.25em;" colspan="2">
            <b-form-select text="請選擇報表類型" class="select_text" style="width: 7rem;" tabindex="2"
              v-model="queryInfo.type">
              <b-form-select-option key="t1" :value="1">明細</b-form-select-option>
              <b-form-select-option key="t2" :value="2">統計</b-form-select-option>
              <b-form-select-option key="t0" :value="0" disabled>請選擇</b-form-select-option>
            </b-form-select>
          </td>
          <td style="padding: 0.25em 1rem; text-align:left;" colspan="3">
            <b-button variant="success" tabindex="3"
                @click="query()"><b-icon icon="search"/>&nbsp;{{$t('message.Query_cmd')}}</b-button>&nbsp;
          </td>
        </tr>
      </tbody>
    </table>
    <b-tabs content-class="mt-3" justified>
        <b-tab title="訊息" :active="dataMode==0" :disabled="dataMode!=0">
          <b-alert show>無相關資料!</b-alert>
        </b-tab>
        <b-tab :active="dataMode==1" :disabled="dataMode!=1">
          <template #title>
            <span v-bind:class="{ 'tab-title': 1==dataMode}">明細報表</span> <span v-show="(0 < total) && (1 == dataMode)">［{{total}}］</span>
          </template>
            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF">
              <thead class="ncut-thead-menu">
                  <tr>
                  <th style="min-width: 3.5rem;">月份</th>
                  <th style="width: 16rem;">單位</th>
                  <th style="width: 3.5rem;">件數</th>
                  </tr>
              </thead>
              <tbody class="ncut-tbody-menu">
                <tr v-for="item in docRecordList"
                  :key="item.id"
                  :index="item.id"
                  :name="item.id" >
                  <td style="text-align: center;">{{item.id}}月</td>
                  <td style="text-align: left; padding: 0; width:100%; line-height: 2;" colspan="2">
                    <table  style="background: transparent; margin: 0; border:1px solid #9ac9ff; width:100%; padding:0;" rules="all">
                      <tr v-for="(dt, dtIdx) in item.data"
                        :key="'dt'+dtIdx"
                        :index="'dt'+dtIdx"
                        :name="'dt'+dtIdx" >
                        <td style="width: 16rem;">{{('' == dt.text1? '無': dt.text1)}} {{dt.text2}}</td>
                        <td style="text-align: right; width: 3.5rem;">{{dt.id1}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
        </b-tab>
        <b-tab :active="dataMode==2" :disabled="dataMode!=2">
          <template #title>
            <span v-bind:class="{ 'tab-title': 2==dataMode}">統計報表</span> <span v-show="(0 < total) && (2 == dataMode)">［{{total}}］</span>
          </template>
          <b-row>
            <b-col sm="3">
              <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF">
                <thead class="ncut-thead-menu">
                    <tr>
                    <th style="min-width: 3.5rem;">月份</th>
                    <th style="width: 5rem;">件數</th>
                    </tr>
                </thead>
                <tbody class="ncut-tbody-menu">
                  <tr v-for="item in docRecordList"
                    :key="item.id"
                    :index="item.id"
                    :name="item.id" >
                    <td style="text-align: center;">{{item.id1}}月</td>
                    <td style="text-align: center;">{{item.id2}}</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col sm="9">
                <GChart
                  :type="chartType"
                  :resizeDebounce="500"
                  :data="chartData"
                  :options="chartOptions" />
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from '@/tool'
import { GChart } from 'vue-google-charts'
export default {
  name: 'formMgt',
  data () {
    return {
      total: 0,
      dataMode: 0,
      nYear: [0, 0],
      queryInfo: {
        sysId: 0,
        no: '',
        text: '',
        sDate: null,
        eDate: null,
        id: 0,
        type: 0
      },
      docRecordList: [],
      chartType: 'BarChart',
      chartData: null,
      chartOptions: {
        legend: { position: 'bottom', alignment: 'start' },
        isStacked: true,
        is3D: true,
        title: '件數統計',
        height: 400,
        width: '90%',
        backgroundColor: '#f0f5e5',
        vAxis: {
          title: '件數',
          titleTextStyle: { color: '#1a6840', fontSize: 14, italic: false, font: 'Arial', bold: true }
        }, // 縱軸設定
        hAxis: {
          title: '月份',
          titleTextStyle: { color: '#411c35', fontSize: 14, italic: false, font: 'Arial', bold: true }
        }, // 橫軸設定
        axisTitlesPosition: 'out'
      }
    }
  },
  components: {
    GChart
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    pickerOpt () {
      return tools.pickerOptions2
    },
  	filteredDocs: function () {
      let data = []
      if (this.docRecordList != null) {
        data = this.docRecordList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  filters: {
    dateFormat: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      return year + '/' + month + '/' + day
    },
    dateFormatV2: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hh = d.getHours()
      var mm = d.getMinutes()
      return tools.stringFormat('{0}/{1}/{2}', year, month, day)
    }
  },
  methods: {
    checkSaveData () {
      const msg = ''

      return msg
    },
    query () {
      var msg = this.checkSaveData()
      if (msg.length == 0) {
        const vm = this
        this.docRecordList = null
        this.total = 0

        this.$http.put('./WebApi/Meet/GetStatusPrn', this.queryInfo)
          .then((response) => {
            if (!tools.isNull(response.data)) {
              vm.docRecordList = response.data
              vm.total = vm.docRecordList.length
            }
            vm.dataMode = (vm.total > 0 ? vm.queryInfo.type : 0)
            if (vm.dataMode == 2) {
              var val1 = ['月份', '件數']
              vm.chartData = [val1]
              for (var i = 1; i <= 12; i++) {
                var val2 = []
                var tVal = 0
                val2.push(i + '月')
                for (var j = 0; j < vm.total; j++) {
                  if (vm.docRecordList[j].id1 == i) {
                    tVal = vm.docRecordList[j].id2
                    break
                  }
                }
                val2.push(tVal)
                vm.chartData.push(val2)
              }
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,' + msg)
      }
    }
  },
  created () {
    console.log('======created StatusPrn =====')
    var today = new Date()
    var yy = today.getFullYear()
    this.queryInfo.sysId = this.sysId
    this.queryInfo.id = yy
    if (!isNaN(yy)) {
      this.nYear[0] = yy - 10
      this.nYear[1] = yy + 10
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
</style>
